export default __webpack_public_path__ + "static/media/fitscreen.720a7752.svg";